"use strict";
var hlp = require('common/helpers');
var HISTTIMEREGEX = /^(\s*((\d{1,4}-(\d{1,4})?)|(-?\d{1,4}))?\s*)$/;
var MEASUREMENTREGEX = /^((\s*\d+(,\d+)?\s*)?(\s*[xX]\s*(\s*\d+(,\d+)?\s*)?)?(\s*[xX]\s*(\s*\d+(,\d+)?\s*)?)?(\s*\(.+\))?)$/;
var FLOATREGEX = /^\s*((\d*[.,]\d+)|(\d+([,.]\d*)?))\s*$/;
var validate = function(schema, entry) {
  if (!validateValidation(schema, entry)) {
    return false;
  }
  switch (schema.type) {
    case 'string':
      if (hlp.isSet(schema.thesaurus)) {
        return validateThesaurus(entry);
      } else {
        return true;
      }
    case 'integer':
      return validateInteger(schema, entry);
    case 'historicaltime':
      return validateHistoricalTime(schema, entry);
    case 'measurement':
      return validateMeasurement(schema, entry);
    case 'geolocation':
      return validateGeolocation(schema, entry);
    case 'archivnr':
    case 'bildnr':
    default:
      return true;
  }
};
var regexValidation = function(regex) {
  return function(schema, entry) {
    if (!_.isNil(entry.value))
      return regex.test(entry.value);
    else
      return true;
  };
};
var validateMeasurement = regexValidation(MEASUREMENTREGEX);
var validateHistoricalTime = regexValidation(HISTTIMEREGEX);
var validateLength = function(schema, entry) {
  var v = schema.validation;
  if (!hlp.isSet(entry.value) && (hlp.isSet(v.minlength) || hlp.isSet(v.maxlength))) {
    return false;
  }
  var l = entry.value.length;
  if (hlp.isSet(v.maxlength) && l > v.maxlength) {
    return false;
  }
  if (hlp.isSet(v.minlength) && l < v.minlength) {
    return false;
  }
  return true;
};
var validateThesaurus = function(entry) {
  return !!entry.thesaurus_id;
};
var validateValidation = function(schema, entry) {
  if (!hlp.isSet(schema.validation)) {
    return true;
  }
  if (!validateLength(schema, entry)) {
    return false;
  }
  if (schema.validation.empty == false && !hlp.isSet(entry.value)) {
    return false;
  }
  if (hlp.isSet(schema.validation.regex) && hlp.isSet(entry.value)) {
    var RE = new RegExp(schema.validation.regex);
    if (!RE.test(entry.value)) {
      return false;
    }
  }
  return true;
};
var validateInteger = function(schema, entry) {
  var RE = /^-{0,1}\d*$/;
  if (!RE.test(entry.value)) {
    return false;
  }
  return true;
};
var validateGeolocation = function(schema, entry) {
  if (!entry.value || entry.value.trim() == '')
    return true;
  var latlng = parseGeolocation(entry.value);
  if (!latlng)
    return false;
  else
    return true;
};
var parseGeolocation = function(value) {
  var latlong = splitCoordinates(value);
  if (latlong.length != 2)
    return null;
  var match = FLOATREGEX.exec(latlong[0]);
  if (!match)
    return null;
  var lat = parseFloat(match[0].replace(/[,.]/g, '.'));
  if (isNaN(lat))
    return null;
  var match = FLOATREGEX.exec(latlong[1]);
  if (!match)
    return null;
  var lng = parseFloat(match[0].replace(/[,.]/g, '.'));
  if (isNaN(lng))
    return null;
  return [lat, lng];
};
var splitCoordinates = function(value) {
  var maxlen = 2;
  var separators = [';', ' '];
  var coords = [];
  separators.forEach(function(sep) {
    var coordTmp = value.split(sep);
    if (coordTmp.length == maxlen) {
      coords = coordTmp;
    }
  });
  return coords;
};
module.exports = {
  validate: validate,
  parseGeolocation: parseGeolocation
};
